import { render, staticRenderFns } from "./changeBillingAddress.component.vue?vue&type=template&id=36edee58&scoped=true&"
import script from "./changeBillingAddress.component.vue?vue&type=script&lang=tsx&"
export * from "./changeBillingAddress.component.vue?vue&type=script&lang=tsx&"
import style0 from "./changeBillingAddress.component.vue?vue&type=style&index=0&id=36edee58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edee58",
  null
  
)

export default component.exports